import VMSConstants from "@/constants";

export const useThemeConstants = () => {
  return VMSConstants.theme;
};
